/**
 * EliorGroup.Time.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MatchCancellationCategory = 0 | 1 | 2 | 3 | 4;

export const MatchCancellationCategory = {
    NUMBER_0: 0 as MatchCancellationCategory,
    NUMBER_1: 1 as MatchCancellationCategory,
    NUMBER_2: 2 as MatchCancellationCategory,
    NUMBER_3: 3 as MatchCancellationCategory,
    NUMBER_4: 4 as MatchCancellationCategory
};

